<template>
  <el-container
      class="worktable-container"
      v-loading="workTableLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <el-header>
      <!-- <Header></Header> -->
    </el-header>
    <el-main class="container-main work_table">
      <el-row style="display:flex">
        <el-col :span="17" class="work_table_board work_table_board_left">
          <div>
            <div class="flex_between">
              <span>{{ this.username }}，您辛苦啦~</span><i class="refresh_i el-icon-refresh"
                                                           @click="getSeatAndTodoInfo"></i>
            </div>
            <div class="seat_data_board">
              <div>
                <div class="board" style="display: flex;justify-items: center;">
                  <div v-for="(item, index) in seatDataList" :key="index" class="seat_data_board_item" v-show="index<2">
                    <div class="seat_data_board_icon" :style="item.background"><i :class="item.icon"></i></div>
                    <div>
                      <div style="margin: 10px 0;font-size:16px;color: #999;">{{ item.title }}</div>
                      <div style="margin: 10px 0;font-size:20px;font-weight:bold;">{{ item.value }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="border-left: 1px solid #D9D9D9;flex:1;">
                <div style="margin:10px;text-align:center;font-size: 18px;font-weight: bold;">待办信息</div>
                <div>
                  <div class="todo-board">
                    <div class="seat_data_board_item2">
                      <div class="seat_data_board_icon" :style="seatDataList[2].background"><i
                          :class="seatDataList[2].icon"></i></div>
                      <div>
                        <div style="margin: 10px 0;font-size:16px;color: #999;">{{ seatDataList[2].title }}</div>
                        <div class="todo_number todo_number_red"
                             @click="todoDialogShow(seatDataList[2])">
                          {{ seatDataList[2].value }}
                        </div>
                      </div>
                    </div>
                    <div class="seat_data_board_item2">
                      <div class="seat_data_board_icon" :style="seatDataList[3].background"><i
                          :class="seatDataList[3].icon"></i></div>
                      <div>
                        <div style="margin: 10px 0;font-size:16px;color: #999;">{{ seatDataList[3].title }}</div>
                        <div class="todo_number todo_number_red"
                             @click="todoDialogShow(seatDataList[3])">
                          {{ seatDataList[3].value }}
                        </div>
                      </div>
                    </div>
                    <div class="seat_data_board_item2 unfinished" @mouseenter="unfinishedTooltip=true "
                         @mouseleave="unfinishedTooltip=false">
                      <div class="seat_data_board_icon" :style="seatDataList[4].background"><i
                          :class="seatDataList[4].icon"></i></div>
                      <div>
                        <div style="margin: 10px 0;font-size:16px;color: #999;">{{ seatDataList[4].title }}</div>
                        <div class="todo_number" @click="tobeCompletedShow"> {{ seatDataList[4].value }}</div>
                      </div>
                      <div v-show="unfinishedTooltip&&seatDataList[4].value!='-'" class="unfinished_tooltip">
                        今日你还有{{ seatDataList[4].value }}个待完成的任务，加油哦~
                      </div>
                    </div>
                    <!-- 待投票 -->
                    <div class="seat_data_board_item2" v-if="seatDataList[5].value>0">
                      <div class="seat_data_board_icon" :style="seatDataList[5].background"><i
                          :class="seatDataList[5].icon"></i></div>
                      <div>
                        <div style="margin: 10px 0;font-size:16px;color: #999;">{{ seatDataList[5].title }}</div>
                        <div class="todo_number todo_number_red"
                             @click="goBestCase">
                          {{ seatDataList[5].value }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- 我的任务 -->
          <div class="my_task">
            <div class="flex_between my_task_top">
              <span style="font-weight: bold;">我的任务</span>
              <span class="all" @click="$router.push({path:'/taskList'})">查看全部</span>
            </div>
            <el-row :gutter="20" v-if="taskDetailList.length>0">
              <el-col :span="12" v-for="(item, index) in taskDetailList" :key="index" class="my_task_item">
                <span class="right_top">{{ item.taskSourceTypeName }}</span>
                <div class="task_board">
                  <div class="task_name">{{ item.followUpTaskName }}</div>
                  <div class="followup">
                    <span>ID：{{ item.followUpTaskId }}</span>
                    <span>结束时间：{{ item.taskEndTime }}</span>
                    <el-button type="primary" size="mini" @click="startFollowup(item)" :disabled="!item.isFollowup">
                      开始随访
                    </el-button>
                  </div>
                  <div class="followup_data">
                    <div v-for="(data, index) in item.dataInfo" :key="index" class="followup_data_item">
                      <div>{{ data.label }}</div>
                      <div>{{ data.value }}</div>
                    </div>
                  </div>
                  <div style="text-align:right;margin-right: 75px;">
                    <span style="color: #4095E5;cursor: pointer;" @click="openDetail(item)">...查看更多</span>
                  </div>
                  <div class="task_pro_wait">
                    <span>已随访：<span style="color: #4095E5;">{{ item.taskCompleteNumber }}</span></span>
                    <span>待随访：<span style="color: #4095E5;">{{ item.taskWaitNumber }}</span></span>
                  </div>
                  <div class="task_progress">
                    <el-progress :percentage="item.taskCompleteRateNum"
                                 :text-inside="true"
                                 :format="format"
                                 :stroke-width="16"
                                 text-color="#fff"
                    ></el-progress>

                    <div style="font-size: 14px;">总人数：{{ item.taskTotalNumber }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-else>
              <div class="no_data">
                <img src="./images/no-result.png" alt="暂无任务">
                <p>暂无任务</p>
              </div>
            </el-row>
          </div>

          <!-- 日周月统计 -->
          <div class="my_statistics">
            <dataStatistics></dataStatistics>
          </div>
        </el-col>
        <el-col :span="7" class="work_table_board work_table_board_right">

          <div class="board_list last_week_board">
            <el-carousel height="260px" :interval="5000">
              <el-carousel-item>
                <div style="text-align: center;font-weight: bold;margin-bottom: 5px;">上周之星</div>
                <div class="content" v-if="lastWeekStar.length>0">
                  <div v-for="(item, index) in lastWeekStar" :key="index">
                    <div class="content_text" v-html="item.contentHtml"></div>
                    <div class="zan">
                      {{ item.clickLikeNumber }}
                      <i @click="clickLikeHandler(item)" v-if="item.isClickLike" class="iconfont icon-dianzan_kuai"></i>
                      <i @click="clickLikeHandler(item)" v-else class="iconfont icon-dianzan"></i>
                    </div>
                  </div>
                </div>
                <div class="content" v-else style="color: gray;">敬请期待~</div>
                <div class="view_history"><span
                    @click="historyListObj.historyListDialogVisible=true">...查看历史榜单</span>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div style="text-align: center;font-weight: bold;margin-bottom: 5px;">最佳随访案例</div>
                <div class="content" v-if="recentNewsData">
                  <p v-html="recentNewsData"></p>
                </div>
                <div class="content" v-else style="color: gray;">敬请期待~</div>
                <div class="view_followup">
                  <span @click="goBestCase">查看最佳随访案例</span>
                  <span @click="openCaseRecord">...查看历史榜单</span>
                </div>
              </el-carousel-item>
            </el-carousel>

          </div>
          <div class="board_list">
            <div style="text-align: center;font-weight: bold;">本月摘星榜</div>
            <div>
              <el-table :data="currentMonthTable" style="width: 100%" size="small " :header-cell-style="rowStyle">
                <el-table-column prop="weekRange" label="日期"></el-table-column>
                <el-table-column prop="seatName" label="坐席"></el-table-column>
                <el-table-column prop="reward" label="奖励"></el-table-column>
                <el-table-column prop="achievement" label="绩效加分"></el-table-column>

              </el-table>
            </div>
          </div>
          <div class="board_list" style="margin-bottom: 0;flex: 1;">
            <div class="wheelCastingTable">
              <el-carousel indicator-position="outside">
                <el-carousel-item v-for="(item, index) in tableObj" :key="index">
                  <div>

                    <div class="top">
                      <span class="title">{{ item.title }}</span>
                      <span class="ranking">当前我的排名：{{ item.ranking }}</span>
                    </div>
                    <el-table :data="item.tableData" style="width: 100%" size="small " :header-cell-style="rowStyle">
                      <el-table-column v-for="(col,col_index) in item.columns" :prop="col.value" :label="col.label"
                                       :key="col_index">
                        <template slot-scope="scope">
                          <span :class="col.value=='seatName'&&scope.row.rankIndex==item.ranking?'my_ranking':''">{{
                              scope.row[col.value]
                            }}</span>
                          <img src="./images/crown.png" v-if="col.value=='seatName'&&scope.row.rankIndex=='1'"
                               style="width: 18px;height: 18px;transform: rotate(45deg);" alt=""/>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-carousel-item>
              </el-carousel>
              <div class="bottom_tip">统计范围为上周的数据</div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="work_table_board" style="padding: 15px 30px;">
        <div style="font-size:14px;color:gray"><span
            style="font-weight: bold;font-size: 16px;color:#000;">随访情况</span>（近7日）
        </div>
        <div id="chart" class="line_chart"></div>
      </el-row>
    </el-main>
    <!-- 其他 -->
    <div v-if="this.taskDialogVisible">
      <el-dialog :visible.sync="taskDialogVisible" width="40%">
        <taskDetailDialog ref="taskDetailDialog" :taskInfo="taskDialogData"></taskDetailDialog>
      </el-dialog>
    </div>
    <!-- 上周之星历史榜单 -->
    <div v-if="this.historyListObj.historyListDialogVisible">
      <el-dialog :visible.sync="historyListObj.historyListDialogVisible" width="40%" title="历史榜单"
                 class="history_list_dialog">
        <div class="content">
          <div style="margin-bottom: 15px;">
            <label>请选择月份：</label>
            <el-date-picker
                v-model="historyListObj.monthSelected"
                type="month"
                value-format="yyyy-MM"
                @change="monthChange"
                placeholder="选择月">
            </el-date-picker>
          </div>
          <div>
            <el-table :data="historyListObj.historyListData" style="width: 100%" size="small " height="400px"
                      :header-cell-style="rowStyle">
              <el-table-column prop="weekRange" label="日期"></el-table-column>
              <el-table-column prop="seatName" label="坐席"></el-table-column>
              <el-table-column prop="reward" label="奖励"></el-table-column>
              <el-table-column prop="achievement" label="绩效加分"></el-table-column>
            </el-table>
          </div>
        </div>
      </el-dialog>
    </div>
    <div>
      <WeekStar ref="WeekStar" @close="closeWeekstar"></WeekStar>
    </div>
    <div class="weekstar_model" v-if="showWeekstarModel"></div>
    <!-- 强制消息推送 -->
    <div>
      <el-dialog :show-close="false" :close-on-click-modal="false" :visible.sync="systemMessageDialog" width="80%"
                 title="" class="system_message_dialog">
        <div class="container">
          <div v-if="systemMessage.length>0">
            <div class="title">{{ systemMessage[systemMessageIndex].classificationTitle }}</div>
            <div class="content" v-html="systemMessage[systemMessageIndex].content"></div>
            <div style="font-weight: 700;margin-top: 10px;font-size: 18px;margin-bottom: 15px;"
                 v-if="systemMessage[systemMessageIndex].quotaDetail">
              <span style="margin-right: 15px;">{{ systemMessage[systemMessageIndex].quotaDetail.timeStr }}</span>
              <span>{{ systemMessage[systemMessageIndex].quotaDetail.beginTime }}</span>
              ~
              <span>{{ systemMessage[systemMessageIndex].quotaDetail.endTime }}</span>
            </div>
            <div>
              <quotaTable :classification="systemMessage[systemMessageIndex].classification"
                          v-if="systemMessage[systemMessageIndex].quotaDetail"
                          :quotaDetail="systemMessage[systemMessageIndex].quotaDetail"></quotaTable>
            </div>
          </div>
          <div style="font-size: 18px;font-weight: 700;margin: 15px 0 ;">
            如有疑问，请在企业微信联系医学负责人或培训专家
          </div>
          <!--          <div class="foot_btn">-->
          <!--            <el-button size="small" type="primary" v-if="systemMessageIndex>0" @click="getPage(1)">上一个</el-button>-->
          <!--            <el-button size="small" type="primary" v-if="systemMessageIndex<systemMessage.length-1" @click="getPage(2)">-->
          <!--              下一个-->
          <!--            </el-button>-->

          <!--          </div>-->
        </div>
        <span slot="footer" class="dialog-footer">
          <div
              v-if="systemMessage.length && systemMessage[systemMessageIndex] && !systemMessage[systemMessageIndex].isConfirm">
            <el-button size="mini" @click="systemMessageDialog = false" type="danger">暂不确认</el-button>
            <el-button size="mini" type="primary" @click="confirmStatusHandler">确认收到</el-button>
          </div>
          <div v-else>
            <el-button @click="systemMessageDialog = false" size="mini" type="primary">关闭弹窗</el-button>
            <el-button disabled size="mini" type="primary">已确认</el-button>

          </div>

        </span>
      </el-dialog>
      <el-dialog :visible.sync="todoListDialog" width="42%" title="" class="todo_list_dialog">
        <div class="content" style="min-height: 240px;">
          <div class="todo_top" v-if="todoListDialogType==1">
            今日待重拨：{{ getSeatFinishAndTodoData.todayRedialTotalCount }}<span
              style="padding:0 15px;color: rgba(0,0,0,0);">1</span>历史待重拨数：{{
              getSeatFinishAndTodoData.todoRedialTotalCount
            }}
          </div>
          <div class="todo_top" v-if="todoListDialogType==4">
            今日待修改：{{ getSeatFinishAndTodoData.todayChangeTotalCount }}<span
              style="padding:0 15px;color: rgba(0,0,0,0);">1</span>历史待修改数：{{
              getSeatFinishAndTodoData.todoChangeTotalCount
            }}
          </div>
          <div class="todo_table" v-for="(item, index) in todoList" :key="index" @click="goPatientDetail(item)">
            <span style="width: 14%;">患者：{{ item.followupPatientName || '-' }}</span>
            <span style="width: 39%;">{{ item.followUpTaskName || '-' }}</span>
            <span style="width: 30%;">质控时间：{{ item.spotCheckTime || '-' }}</span>
            <span style="width: 17%;">质控员： {{ item.spotCheckUserName || '-' }}</span>
          </div>
          <div class="todo_bottom" v-if="todoTotalCount>1">历史待办事项累计超过5个将无法开始新任务，请立即处理<i
              class="el-icon-warning"></i></div>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="tobeCompletedDialog" width="42%" title="" class="todo_list_dialog">
        <div class="content" style="min-height: 240px;">
          <div class="todo_top">
            每日24点更新，统计时间为每月月初至今日，统计数据为当月总数据，数据说明：完成/指标
          </div>
          <el-table :data="tobeCompletedList" style="width: 100%" max-height="380">
            <el-table-column prop="followUpTaskId" label="任务ID" align="center"></el-table-column>
            <el-table-column prop="followUpTaskName" label="任务名称" width="330" align="center"></el-table-column>
            <el-table-column prop="callQuotaTotal" label="呼叫人数总指标" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.callQuotaComplete<scope.row.callQuotaTotal"
                      style="color:rgb(255, 0, 0);">{{ scope.row.callQuotaComplete }}/{{ scope.row.callQuotaTotal }}</span>
                <span v-else
                      style="color:rgb(0, 128, 0);">{{ scope.row.callQuotaComplete }}/{{ scope.row.callQuotaTotal }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="followupQuotaTotal" label="随访情况总指标" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.followupQuotaComplete<scope.row.followupQuotaTotal" style="color:rgb(255, 0, 0);">{{ scope.row.followupQuotaComplete }}/{{ scope.row.followupQuotaTotal }}</span>
                <span v-else
                      style="color:rgb(0, 128, 0);">{{ scope.row.followupQuotaComplete }}/{{ scope.row.followupQuotaTotal }}</span>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </el-dialog>
    </div>
    <el-dialog
        title="历史榜单"
        :visible.sync="caseRecordDialog.show"
        width="42%">
      <div class="case-record-dialog">
        <div>
          请选择月份：
          <el-date-picker
              :clearable="false"
              v-model="caseRecordDialog.pullMonth"
              type="month"
              size="small"
              class="my-date-picker"
              value-format="yyyy-MM"
              @change="monthChangeCase"
              placeholder="选择月">
          </el-date-picker>
        </div>
        <div style="margin: 15px 0;" class="case-record-table">
          <el-table :data="caseRecordDialog.tableData"
                    border style="width: 100%"
                    height="420"
                    :header-cell-style="rowClass"
          >
            <el-table-column prop="taskName" label="任务" width="230"></el-table-column>
            <el-table-column prop="admitNo" label="住院号"></el-table-column>
            <el-table-column prop="seatName" label="坐席"></el-table-column>
            <el-table-column prop="cash" label="奖励"></el-table-column>
            <el-table-column prop="performanceScore" label="绩效加分"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <!-- <el-footer>
      <Footer></Footer>
    </el-footer> -->
  </el-container>
</template>
<script type="text/ecmascript-6">
import quotaTable from "./components/quotaTable";
import echarts from 'echarts'
import Vue from 'vue'
// import Header from "../common/Header";
// import Footer from "../common/Footer";
import {mapGetters, mapMutations} from "vuex";

import taskDetailDialog from "./components/workTable/taskDetailDialog.vue";
import dataStatistics from './components/workTable/dataStatistics.vue'
import WeekStar from './components/WeekStar.vue'

import {MyMixin} from "@mixins/aliyunCallMixin"

Vue.prototype.$echarts = echarts

export default {
  name: "workTable",
  data() {
    return {
      workTableLoading: false,
      seatDataList: [
        {
          key: 'historyFinishTotalCount',
          title: '历史完成人数',
          value: 0,
          icon: ' el-icon-s-claim',
          background: 'background-color:#ECA076;'
        },
        {
          key: 'historyCallTimeTotalCount',
          title: '历史呼叫总时长（h）',
          value: 0,
          icon: ' el-icon-s-opportunity',
          background: 'background-color:#6B63F2;'
        },
        {
          key: 'todoRedialTotalCount',
          title: '待重拨',
          value: 0,
          icon: ' el-icon-phone',
          background: 'background-color:#3EA5F0;'
        },
        {
          key: 'todoChangeTotalCount',
          title: '待修改',
          value: 0,
          icon: ' el-icon-edit-outline',
          background: 'background-color:#3D73E0;'
        },
        {
          key: 'todoCompleteQuotaTotalCount',
          title: '待完成指标',
          value: 0,
          icon: ' el-icon-s-order',
          background: 'background-color:#93D2F3;'
        }, {
          key: 'todoVoteCount',
          title: '待投票',
          value: 0,
          icon: ' el-icon-s-data',
          background: 'background-color:rgb(106, 137, 249);'
        },
      ],
      taskDetailList: [],
      taskDialogVisible: false,
      taskDialogData: {},
      // 右侧榜单数据
      dianzanIconShow: false,
      currentMonthTable: [],
      historyListObj: {
        historyListDialogVisible: false,
        monthSelected: null,
        historyListData: [],
      },
      sourceTypeLists: [
        {label: "医院", value: "1"},
        {label: "公司", value: "2"},
        {label: "荟医", value: "3"},
        {label: "其他", value: "4"},
      ],
      lastWeekStar: [],
      bestFollowupData: "",
      tableObj: [
        {
          title: '勤奋榜',
          ranking: '',
          columns: [
            {value: 'rankIndex', label: '排名'},
            {value: 'seatName', label: '姓名'},
            {value: 'rankData', label: '指标完成率'},
          ],
          tableData: []
        }, {
          title: '优质榜',
          ranking: '',
          columns: [
            {value: 'rankIndex', label: '排名'},
            {value: 'seatName', label: '姓名'},
            {value: 'rankData', label: '质控合格率'},
          ],
          tableData: []
        }, {
          title: '效率榜',
          ranking: '',
          columns: [
            {value: 'rankIndex', label: '排名'},
            {value: 'seatName', label: '姓名'},
            {value: 'rankData', label: '工作时间效率'},
          ],
          tableData: []
        }, {
          title: '成功榜',
          ranking: '',
          columns: [
            {value: 'rankIndex', label: '排名'},
            {value: 'seatName', label: '姓名'},
            {value: 'rankData', label: '随访成功率'},
          ],
          tableData: []
        }
      ],
      showWeekstarModel: false,
      // 消息推送
      systemMessage: [],
      systemMessageIndex: 0,
      systemMessageDialog: false,
      todoListDialog: false,
      todoTotalCount: 0,
      todoList: [],
      todoListDialogType: 1,
      getSeatFinishAndTodoData: {},
      unfinishedTooltip: false,
      caseRecordDialog: {
        show: false,
        pullMonth: "",
        tableData: [],
      },
      recentNewsData: "",
      tobeCompletedDialog: false,
      tobeCompletedList: []
    }
  },
  computed: {
    ...mapGetters([
      "username",
      "userid",
    ]),
  },
  components: {
    taskDetailDialog, dataStatistics, WeekStar, quotaTable
  },
  mixins: [MyMixin],
  created() {
  },
  mounted() {
    let vm = this
    vm.onload()
  },
  watch: {},
  methods: {
    ...mapMutations([
      'setTaskTitle',
      'setTaskCenterId',
      "setQuestion"
    ]),
    rowStyle({row, rowIndex}) {
      if (rowIndex == 0) {
        return 'color:#000;background:#F2F3F8;font-size:14px; font-weight:bold;'
      }
    },
    format(percentage) {
      return `完成：${percentage}%`;
    },
    onload() {
      var date = new Date();
      this.currentMonth = date.getFullYear() + '-' + ((date.getMonth() + 1) < 9 ? `0${date.getMonth() + 1}` : (date.getMonth() + 1))
      this.historyListObj.monthSelected = this.currentMonth

      // 获取坐席强制推送周之星
      this.getForcePushWeekStar()
      console.log('fromLogin is ', this.$route.params.fromLogin);
      if (this.$route.params.fromLogin) {
        this.getSystemMessage()
      }

      this.getSeatAndTodoInfo()
      this.getRecentActiveTaskInfo()
      this.getMessageWeekStar()
      this.getMonthAllWeekStar() //查看历史榜单
      this.getRecentNews()

      this.getCurrentMonthAllRank()//轮播表格数据

      this.getChartData()
    },

    getForcePushWeekStar() {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerGetForcePushWeekStar',
            params: {seatId: this.userid}
          }
      ).then(res => {
        if (res.status == 0) {
          if (res.retValue) {
            this.$refs.WeekStar.show();
            this.showWeekstarModel = true
          }
        }
      })
    },
    getPage(type) {
      // this.systemMessageIndex = type == 1 ? this.systemMessageIndex-- : this.systemMessageIndex++
      if (type == 1) {
        this.systemMessageIndex -= 1
      } else {
        this.systemMessageIndex += 1
      }
      this.getQuotaTableInfoAsync({
        seatId: this.userid,
        messageId: this.systemMessage[this.systemMessageIndex].id,
        classification: this.systemMessage[this.systemMessageIndex].classification
      }).then(res => {
        this.systemMessage[this.systemMessageIndex].quotaDetail = res.retValue
        this.$forceUpdate()
      })
    },
    // 消息强制推送
    getSystemMessage() {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerGetSystemMessage',
            params: {
              seatId: this.userid,
              isRead: false,
              isForceSend: true
            }
          }
      ).then(res => {
        if (res.status == 0) {
          this.systemMessage = res.retValue.map(item => {
            item.classificationTitle = item.classification == 2 ? "指标核对" : (item.classification == 3 ? "工作计划" : "")
            return item
          })
          this.getQuotaTableInfoAsync({
            seatId: this.userid,
            messageId: this.systemMessage[0].id,
            classification: this.systemMessage[0].classification
          }).then(res => {
            if (res.retValue && res.retValue.tableInfo.length > 0) {
              this.systemMessage[0].quotaDetail = res.retValue
              if (this.systemMessage.length > 0 && !this.systemMessage[0].isConfirm) {
                this.systemMessageDialog = true
              }
              this.$forceUpdate()
            }
          })
          this.systemMessageIndex = 0
        }
      })
    },
    confirmStatusHandler() {
      this.confirmStatus({
        userId: this.userid,
        messageId: this.systemMessage[0].id,
        classification: this.systemMessage[0].classification
      }).then(res => {
        if (res.status == 0) {
          this.$message.success(res.retValue)
          this.systemMessageDialog = false
        } else {
          this.$message.error(res.retValue)
        }
      })
    },
    async confirmStatus(p) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestCallCenterOperationPlatformControllerUpdateMsgConfirmStatus',
        params: {
          userId: p.userId,
          messageId: p.messageId,
          classification: p.classification,
        }
      })
      return result
    },

    //获取坐席完成和待办信息
    getSeatAndTodoInfo() {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerGetSeatFinishAndTodoInfo',
            params: {seatId: this.userid}
          }
      ).then(res => {
        if (res.status == 0) {
          this.getSeatFinishAndTodoData = res.retValue
          this.seatDataList = this.seatDataList.map(item => {
            if (res.retValue[item.key]) {
              if (item.key == 'historyCallTimeTotalCount') {
                item.value = (res.retValue[item.key] / (60 * 60)).toFixed(3)
              } else {
                item.value = res.retValue[item.key]
              }
            } else {
              item.value = "-"
            }
            return item
          })
        }
      })
    },
    // 我的任务
    getRecentActiveTaskInfo() {
      this.workTableLoading = true
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerGetRecentActiveTaskInfo',
            params: {seatId: this.userid}
          }
      ).then(res => {
        if (res.status == 0) {
          this.taskDetailList = res.retValue.map(item => {
            item.taskSourceTypeName = this.sourceTypeLists.find(type => type.value == item.taskSourceType).label
            item.allTaskFollowupData.validTalkTimeMedianStr = this.formatDuring(item.allTaskFollowupData.validTalkTimeMedian * 1000) //中位数单位是 秒
            item.allTaskFollowupData.avgCompleteValidTimeStr = this.formatDuring(item.allTaskFollowupData.avgCompleteValidTime) //平均通话时长单位是 毫秒

            item.dataInfo = [
              {
                name: 'successNumber',
                label: '成功',
                value: `${item.allTaskFollowupData['successNumber']}(${item.allTaskFollowupData['successRate']})`
              },
              {
                name: 'validTalkTimeMedian',
                label: '有效通话时长中位数',
                value: item.allTaskFollowupData['validTalkTimeMedianStr']
              },
              {
                name: 'loseNumber',
                label: '失访',
                value: `${item.allTaskFollowupData['loseNumber']}(${item.allTaskFollowupData['loseRate']})`
              },
              {
                name: 'avgCompleteValidTime',
                label: '平均通话时长',
                value: item.allTaskFollowupData['avgCompleteValidTimeStr']
              },
              {
                name: 'refuseNumber',
                label: '未成功',
                value: `${item.allTaskFollowupData['refuseNumber']}(${item.allTaskFollowupData['refuseRate']})`
              },
              {
                name: 'qualityPersonNumber',
                label: '当前被质控',
                value: item.allTaskFollowupData['qualityPersonNumber']
              },
              {name: 'laterNumber', label: '稍后拨打', value: item.allTaskFollowupData['laterNumber']},
              {name: 'qualifiedRate', label: '质控合格率', value: item.allTaskFollowupData['qualifiedRate']},
              {name: 'exceptionNumber', label: '异常随访', value: item.allTaskFollowupData['exceptionNumber']},
            ]
            item.taskCompleteRateNum = (item.taskCompleteRate.replace('%', '')) * 1;
            return item
          })
          this.workTableLoading = false
        } else {
          this.workTableLoading = false
          this.taskDetailList = []
        }
      })
    },
    // 上周之星
    getMessageWeekStar() {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerGetMessageWeekStar',
            params: {seatId: this.userid}
          }
      ).then(res => {
        if (res.status == 0) {
          this.lastWeekStar = res.retValue.map(item => {
            let _content = item.content.match(/([^，]*)，(.*)/);
            item.contentHtml = `
            <div>&nbsp;&nbsp;&nbsp;&nbsp;${_content[1]}，</div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;${_content[2]}组织表示强烈认可，将发放现金奖励以及绩效分给予肯定。</div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;也希望各位小伙伴们向榜首看齐，加油！</div>
            `
            return item
          })
        }
      })
    },
    // 最佳随访案例
    getRecentNews() {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestBestFollowupCaseCallcenterControllerRecentNews',
            params: {}
          }
      ).then(res => {
        if (res.status == 0) {
          this.recentNewsData = res.retValue
        }
      })
    },
    // 点赞或取消点赞
    clickLikeHandler(param) {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerClickLikeOrCancel',
            params: {
              seatId: this.userid,
              weekStarId: param.id,
              clickLike: !param.isClickLike
            }
          }
      ).then(res => {
        if (res.status == 0) {
          param.isClickLike = res.retValue.isClickLike
          param.clickLikeNumber = res.retValue.clickLikeNumber
        }
      })
    },
    // 本月摘星、查看历史榜单
    getMonthAllWeekStar() {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerGetMonthAllWeekStar',
            params: {yearMonth: this.currentMonth}
          }
      ).then(res => {
        if (res.status == 0) {
          this.currentMonthTable = res.retValue.map(item => {
            item.weekRange = this.weekTime(item.weekStartTime) + '~' + this.weekTime(item.weekEndTime)
            return item
          })
          this.historyListObj.historyListData = res.retValue.map(item => {
            item.weekRange = this.weekTime(item.weekStartTime) + '~' + this.weekTime(item.weekEndTime)
            return item
          })
        }
      })
    },
    goBestCase() {
      this.$router.push("/bestFollowupCase");
    },
    openCaseRecord() {
      this.caseRecordDialog.show = true

      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      this.caseRecordDialog.pullMonth = year + '-' + month
      this.monthChangeCase()
    },
    weekTime(date) {
      let result = date.substring(5, date.length);
      return result.replace(/-/g, '.')
    },
    monthChange() {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerGetMonthAllWeekStar',
            params: {yearMonth: this.historyListObj.monthSelected}
          }
      ).then(res => {
        if (res.status == 0) {
          this.historyListObj.historyListData = res.retValue.map(item => {
            item.weekRange = this.weekTime(item.weekStartTime) + '~' + this.weekTime(item.weekEndTime)
            return item
          })
        }
      })
    },
    monthChangeCase() {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestBestFollowupCaseCallcenterControllerHistoricalList',
            params: {pullMonth: this.caseRecordDialog.pullMonth}
          }
      ).then(res => {
        if (res.status == 0) {
          this.caseRecordDialog.tableData = res.retValue
        }
      })
    },
    // 当月所有排行榜
    getCurrentMonthAllRank() {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerGetCurrentMonthAllRank',
            params: {
              seatId: this.userid
            }
          }
      ).then(res => {
        if (res.status == 0 && res.retValue.length > 0) {
          this.tableObj = this.tableObj.map((item, index) => {
            item.tableData = res.retValue[index].seatRankList
            if (res.retValue[index].currentSeatIndex == -1) {
              item.ranking = '暂无'
            } else {
              item.ranking = res.retValue[index].currentSeatIndex
            }
            return item
          })
        }
      })
    },


    //获取指标预告 核算
    async getQuotaTableInfoAsync(params) {
      let result = await this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerGetQuotaTableInfo',
            params: {
              seatId: params.seatId,
              messageId: params.messageId,
              classification: params.classification,
            }
          }
      )
      return result
    },
    openDetail(task) {
      this.workTableLoading = true
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerGetTaskDataSeatCompareInfo',
            params: {
              seatId: this.userid,
              followUpTaskId: task.followUpTaskId
            }
          }
      ).then(res => {
        this.workTableLoading = false
        this.taskDialogVisible = true
        this.taskDialogData = res.retValue
        this.taskDialogData.taskCompleteRateNum = (this.taskDialogData.taskCompleteRate.replace('%', '')) * 1;
        // 处理中位数和平均通话时长
        this.taskDialogData.allTaskFollowupData.validTalkTimeMedianHandle = this.formatDuring(this.taskDialogData.allTaskFollowupData.validTalkTimeMedian * 1000)
        this.taskDialogData.myTaskFollowupData.validTalkTimeMedianHandle = this.formatDuring(this.taskDialogData.myTaskFollowupData.validTalkTimeMedian * 1000)
        this.taskDialogData.avgTaskFollowupData.validTalkTimeMedianHandle = this.formatDuring(this.taskDialogData.avgTaskFollowupData.validTalkTimeMedian * 1000)

        this.taskDialogData.allTaskFollowupData.avgCompleteValidTimeHandle = this.formatDuring(this.taskDialogData.allTaskFollowupData.avgCompleteValidTime)
        this.taskDialogData.myTaskFollowupData.avgCompleteValidTimeHandle = this.formatDuring(this.taskDialogData.myTaskFollowupData.avgCompleteValidTime)
        this.taskDialogData.avgTaskFollowupData.avgCompleteValidTimeHandle = this.formatDuring(this.taskDialogData.avgTaskFollowupData.avgCompleteValidTime)

        this.taskDialogData.myTaskFollowupData.qualifiedRateNum = (this.taskDialogData.myTaskFollowupData.qualifiedRate.replace('%', '')) * 1
        this.taskDialogData.avgTaskFollowupData.qualifiedRateNum = (this.taskDialogData.avgTaskFollowupData.qualifiedRate.replace('%', '')) * 1
      })
    },
    getChartData() {
      let chartData = {
        xData: [],
        yData: []
      }
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerGetSeatRecentDayFollowupCount',
            params: {
              seatId: this.userid
            }
          }
      ).then(res => {
        if (res.status == 0) {
          res.retValue.forEach(item => {
            chartData.xData.push(item.followupDate)
            chartData.yData.push(item.lost + item.refuse + item.success)
          })
          chartData.chartDataLists = res.retValue
          this.initCharts(chartData, res.retValue)
        }
      })

    },
    initCharts(params, chartDataLists) {
      var myChart = echarts.init(document.getElementById('chart'))
      // this.chartObj = myChart
      let option = {
        xAxis: {
          type: 'category',
          data: params.xData,
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#ccc'
            }
          },
          axisLine: {
            lineStyle: {
              color: "gray",
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: "gray",
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#ccc'
            }
          },
        },
        series: [
          {
            data: params.yData,
            type: 'line',
            smooth: true,
            lineStyle: {
              normal: {
                color: '#4D69FD'
              }
            },
            itemStyle: {
              normal: {
                color: '#4D69FD'
              }
            },
            areaStyle: {
              //区域背景色
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#4D69FD'
                  }, {
                    offset: 1,
                    color: '#fff'
                  }
                ]),
              }
            }
          }
        ],
        // 自定义折线图上的样式
        tooltip: {
          trigger: 'axis',//触发方式
          axisPointer: {
            z: 0//触发轴层级：默认时层级很高，会遮挡住拐点
          },
          formatter: function (params) {//提示框自定义
            for (var i = 0; i < params.length; i++) {
              for (var j = params.length - 1; j > i; j--) {
                if (params[j].data == params[i].data) {
                  params.splice(j, 1);
                  break;
                }
              }
            }
            var tip = '';
            for (var i = 0; i < params.length; i++) {
              if (params[i].value != 0) {
                let _data = chartDataLists.find(item => item.followupDate == params[i].name)
                tip = tip + '<div class="line_chart_prompt"><div>' + _data.followupDate + '</div>' +
                    '<div class="txt" ><span>成功</span><span>' + _data.success + '</span></div >' +
                    '<div class="txt" ><span>未成功</span><span>' + _data.refuse + '</span></div >' +
                    '<div class="txt" ><span>失访</span><span>' + _data.lost + '</span></div >' +
                    '</div >';
              }
            }
            return tip;
          },
          backgroundColor: 'rgba(255,255,255,0)',//默认有一个背景色，手动将背景色设置我们写入的样式
        }

      }
      myChart.setOption(option)
    },
    startFollowup(item) {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId',
            params: {followupTaskId: item.followUpTaskId}
          }
      ).then(res => {
        if (res.status == 0) {
          this.setQuestion(res.retValue);
        }
      })

      this.$router.push({
        path: "/taskDetail",
        query: {
          isOpen: item.isOpen,
          diseaseId: item.diseaseId,
          isFrontPage: 1,
          isRemindStudy: item.isRemindStudy,
          isSingleDuration: item.isSingleDuration,
          isTotalDuration: item.isTotalDuration,
        },
      });
      this.setTaskTitle(item.followUpTaskName);
      this.setTaskCenterId(item.followUpTaskId);
      localStorage.setItem('isFrontPage', 1)
      localStorage.setItem('taskId', item.followUpTaskId)
    },
    showWeek() {
      this.$refs.WeekStar.show();
      this.showWeekstarModel = true
    },
    closeWeekstar() {
      this.showWeekstarModel = false
    },
    todoDialogShow(param) {
      this.todoListDialog = true
      this.todoListDialogType = param.key == "todoRedialTotalCount" ? 1 : 4
      this.getAllTaskSpotCheckToDoList()
    },
    getAllTaskSpotCheckToDoList() {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestNewFollowupCallCenterServiceGetAllTaskSpotCheckToDoList',
            params: {
              userId: this.userid,
              pageIndex: 1,
              pageSize: 5,
              handleResult: this.todoListDialogType,
            }
          }
      ).then(res => {
        if (res.status == 0) {
          this.todoList = []
          this.todoList = res.retValue
          if (res.retValue.length < 5) {
            let _length = 5 - res.retValue.length
            for (var i = 0; i < _length; i++) {
              this.todoList.push({})
            }
          } else {
            this.todoList = res.retValue
          }
          this.todoTotalCount = res.totalCount
        }
      })
    },
    tobeCompletedShow() {
      this.tobeCompletedList = []
      this.$store.dispatch('requestHandler', {
        fn: 'RestCallCenterOperationPlatformControllerGetSeatMonthQuota',
        params: {
          seatId: this.userid,
        }
      }).then(res => {
        if (res.status == 0) {
          this.tobeCompletedDialog = true
          this.tobeCompletedList = res.retValue
        }
      })
    },
    goPatientDetail(params) {
      console.log(params);
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId',
            params: {
              followupTaskId: params.followUpTaskId,
            }
          }
      ).then(res => {
        this.setQuestion(res.retValue)
        this.setTaskTitle(params.followUpTaskName);
        this.setTaskCenterId(params.followUpTaskId);
        localStorage.setItem('isFrontPage', 1)
        localStorage.setItem('taskId', params.followUpTaskId)
        if (window.workbench) {
          this.$router.push({
            path: "/callPatient",
            query: {
              abnormal: 5,
              followUpPatientInfoId: params.followupPatientInfoId,
              followupPatientId: params.followupPatientId,
              diseaseId: params.diseaseId,
              followupSource: 2,
              isRemindStudy: params.isRemindStudy,
              isSingleDuration: params.isSingleDuration,
              isTotalDuration: params.isTotalDuration,
              spotCheckId: params.spotCheckId,
              type: this.todoListDialogType, // 1:需重拨   4：需修改
            }
          });
        } else {
          const loading = this.$loading({
            lock: true,
            text: '正在登录阿里云请稍后...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.initAliyunCall()
              .then((result) => {
                if (result) {
                  this.$router.push({
                    path: "/callPatient",
                    query: {
                      abnormal: 5,
                      followUpPatientInfoId: params.followupPatientInfoId,
                      followupPatientId: params.followupPatientId,
                      diseaseId: params.diseaseId,
                      followupSource: 2,
                      isRemindStudy: params.isRemindStudy,
                      isSingleDuration: params.isSingleDuration,
                      isTotalDuration: params.isTotalDuration,
                      spotCheckId: params.spotCheckId,
                      type: this.todoListDialogType, // 1:需重拨   4：需修改
                    }
                  });
                  loading.close();
                }
              })
        }
      })

    },
    // 时间处理
    formatDuring(mss) {
      mss = parseInt(mss / 1000)
      if (!mss) return '0 s '
      if (mss > 60) {
        return parseInt(mss / 60) + ' min ' + (mss % 60).toFixed(0) + ' s '
      } else {
        return mss + ' s '
      }
    },
    rowClass() {
      return "background: rgb(242, 243, 248);color: #000;";
    },
  }
}
</script>
<style lang="scss">
.work_table {

  // =========折线图========
  .line_chart_prompt {
    color: #000;
    border-radius: 5px;
    background: #ECF5FD;
    padding: 5px 10px;
    width: 170px;

    .txt {
      display: flex;
      justify-content: space-between;
      padding: 5px;
      border-radius: 5px;
      background: #fff;
      margin-bottom: 5px;
    }
  }

  .wheelCastingTable {
    .el-carousel__container {
      height: 470px;
    }
  }
}

.case-record-table {
  .el-table .el-table__cell {
    padding: 6px 0;
  }
}

.system_message_dialog {
  .el-dialog__body {
    padding-top: 10px;
  }

  strong {
    font-weight: bold !important;
  }

  p {
    word-break: break-all;
    word-wrap: break-word;
    line-height: 1;
  }

  ul {
    padding: 0 1em;
    list-style-type: disc !important;
    list-style-position: inside !important;
  }

  ol {
    padding: 0 1em;
    list-style-type: decimal !important;
    list-style-position: inside !important;
  }

  li {
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
  }
}

.todo_list_dialog {
  .el-dialog {
    border-radius: 8px;
  }

  .el-dialog__body {
    padding: 0 20px 15px 20px;
  }
}
</style>
<style lang="scss" scoped>
.worktable-container {
  font-family: PingFangSC-Regular, sans-serif;
}

.container-main {
  // min-height: calc(100vh - 60px - 60px);
  // min-height: calc(100vh - 60px);
  margin: 0px;
  padding: 0px;
  color: #000;
  position: relative;
}

.work_table {
  padding: 15px;
  // border: 1px solid;
  .flex_between {
    display: flex;
    justify-content: space-between;
  }

  .refresh_i {
    color: #BEBEBE;
    font-size: 18px;
  }

  .refresh_i:hover {
    cursor: pointer;
    font-weight: bold;
  }

  &_board {
    padding: 15px;

    &_right, &_left {
      display: flex;
      flex-direction: column;
    }

    &_left {
      padding-left: 30px;
    }

    &_right {
      padding-right: 30px;
    }
  }

  .seat_data_board {
    margin: 10px 0;
    padding: 10px;
    border: 1px solid #D9D9D9;
    border-radius: 4px;
    display: flex;
    align-items: flex-end;

    &_item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 240px;
    }

    .todo-board {
      display: flex;
      flex-wrap: nowrap;
    }

    &_item2 {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .todo_number {
      margin: 10px 0;
      font-size: 20px;
      font-weight: bold;
      cursor: pointer;

    }

    .todo_number_red {
      color: #F21702;
      cursor: pointer;
    }

    &_icon {
      padding: 5px;
      height: 50px;
      width: 50px;
      border-radius: 50%;
      font-size: 24px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      margin-right: 10px;
    }

    .unfinished {
      position: relative;

      .unfinished_tooltip {
        position: absolute;
        top: -35px;
        left: 0;
        background: rgba(64, 64, 64, 0.33);
        box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 4px 0px;
        border-radius: 8px;
        font-size: 14px;
        height: 30px;
        line-height: 30px;
        padding: 0 8px;
        font-family: AlibabaPuHui;
        font-weight: 400;
        font-size: 13px;
        color: rgb(16, 16, 16);
        width: 270px;
        text-align: center;
      }

    }
  }

  // ========我的任务=======
  .my_task {
    margin: 20px 0;

    .no_data {
      p {
        font-size: 16px;
        font-weight: bold;
        color: rgba(0, 0, 0, .5);
        margin: 15px;
      }

      text-align: center;
    }

    &_top {
      font-size: 18px;
      margin-bottom: 15px;

      .all {
        color: #4095E5;
        cursor: pointer;
      }
    }

    .my_task_item {
      position: relative;

      .right_top {
        background: red;
        height: 22px;
        width: 40px;
        text-align: center;
        line-height: 22px;
        border-radius: 0 0 0 8px;
        font-size: 12px;
        position: absolute;
        top: 0;
        right: 10px;
        color: #fff;
      }
    }

    .task_board {
      // border: 1px solid;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
      padding: 10px;
      min-height: 300px;

      .task_name {
        font-weight: bold;
        margin-right: 40px;
      }

      .followup {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 8px 0;
        color: #999;
      }

      .followup_data {
        display: flex;
        flex-wrap: wrap;
        padding: 0 30px;
        font-weight: bold;
        font-size: 14px;

        &_item {
          display: flex;
          width: 50%;

          & > div {
            width: 55%;
            // text-align: right;
            padding: 5px 5px;
          }
        }

        &_item div:nth-child(2n) {
          width: 45%;
          color: #4095E5;
          text-align: left;
        }
      }

      .task_pro_wait {
        margin: 0 20px;

        & > span {
          margin-right: 50px;
        }
      }

      .task_progress {
        margin-top: 15px;
        padding-left: 20px;
        display: grid;
        grid-template-columns: 80% 20%;
        grid-gap: 10px;
      }
    }
  }

  // ==========日月周统计==========
  .my_statistics {
    padding: 10px;
    border: 1px solid #D9D9D9;
    flex: 1;
  }

  // ==========右边榜单============
  .work_table_board {
    .board_list {
      border: 1px solid #D9D9D9;
      min-height: 200px;
      margin-bottom: 20px;

      & > div {
        margin: 10px 0;
      }
    }

    .last_week_board {
      .content {
        min-height: 200px;
        background: #F2F3F8;
        padding: 10px;
        max-height: 200px;
        overflow: auto;
        margin-bottom: 10px;

        .content_text {
          line-height: 24px;
        }

        .zan {
          text-align: right;
          margin-bottom: 10px;
          color: #4095E5;
          font-size: 16px;

          i {
            font-size: 20px;
            cursor: pointer;
          }
        }
      }

      .view_history {
        cursor: pointer;
        color: #4095E5;
        text-align: right;
      }

      .view_followup {
        cursor: pointer;
        color: #4095E5;
        display: flex;
        justify-content: space-between;
      }
    }

    .line_chart {
      height: 300px;
      // border: 1px solid #ccc;
    }
  }

  .wheelCastingTable {
    .my_ranking {
      font-weight: bold;
    }

    .title {
      font-weight: bold;
    }

    .top {
      display: flex;
      justify-content: space-between;
      margin: 0 10px 10px 10px;
    }

    .bottom_tip {
      font-size: 12px;
      color: #BBB;
      text-align: center;
    }
  }
}

.worktable-container {
  .history_list_dialog {
    .content {
      font-size: 16px;
      color: #000;
    }

  }

  .weekstar_model {
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 99;
  }

  .system_message_dialog {
    .content {
      max-height: 50vh;
      overflow: auto;
    }

    .foot_btn {
      text-align: right;
      // display: flex;
      // justify-content: space-between;
      // &>span {
      //   flex: .5;
      // }
    }

    .title {
      font-weight: 700;
      margin-top: 10px;
      font-size: 18px;
      margin-bottom: 15px;
      text-align: center;
    }
  }

  .todo_list_dialog {
    color: #000;

    .todo_top {
      font-size: 16px;
      margin-bottom: 15px;
    }

    .todo_table {
      margin: 5px 0;
      color: #000;
      padding: 8px 0;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #DDD;
      height: 45px;

      & > span {
        cursor: pointer;
      }

      & > span:nth-child(2) {
        padding-right: 26px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }

    .todo_bottom {
      margin-top: 15px;
      text-align: center;
      color: #F21702;
    }
  }
}
</style>